// extracted by mini-css-extract-plugin
export default {"containerMain":"Links_containerMain__hiI8d","links":"Links_links__iOS-T"};